import { useSubscription } from '../contexts/SubscriptionContext';

/**
 * Universal admin check hook
 * Use this everywhere to check if user is admin
 * Admins bypass ALL restrictions
 */
export const useAdminCheck = () => {
  const { subscription, features } = useSubscription();
  
  const isAdmin = 
    subscription?.is_admin === true ||
    subscription?.tier === 'admin' ||
    features?.tier === 'admin' ||
    features?.is_admin === true;
  
  console.log('🔐 Admin Check:', {
    isAdmin,
    subscription_tier: subscription?.tier,
    subscription_is_admin: subscription?.is_admin,
    features_tier: features?.tier,
    features_is_admin: features?.is_admin
  });
  
  return isAdmin;
};

/**
 * Check if user has feature access
 * Admins always return true
 */
export const useFeatureAccess = (featureName) => {
  const { subscription, features, hasFeature } = useSubscription();
  const isAdmin = useAdminCheck();
  
  if (isAdmin) {
    return true;
  }
  
  return hasFeature(featureName);
};

/**
 * Check if user has unlimited limits
 * Admins always return true
 */
export const useUnlimitedAccess = () => {
  const isAdmin = useAdminCheck();
  const { features } = useSubscription();
  
  if (isAdmin) {
    return true;
  }
  
  // Check if all limits are -1
  const limits = features?.limits || {};
  return Object.values(limits).every(limit => limit === -1);
};

export default useAdminCheck;
